import Url from 'src/common/constants/Url';

export interface LandingPageCard {
  level?: number;
  name: string;
  href?: string;
  description?: string;
  external?: boolean;
}

export interface LandingPageSection {
  title: string;
  cards: LandingPageCard[];
}

export enum LandingPageOption {
  FAM_GAM_AB = 'FAM| GAM| AB',
  SHADOW_PNL = 'Shadow PnL',
  FCFIXED_ALLOCATION = 'CF Allocation',
}

export const landingPageOptions = [
  { label: LandingPageOption.FAM_GAM_AB, value: '0' },
  { label: LandingPageOption.SHADOW_PNL, value: '1' },
  { label: LandingPageOption.FCFIXED_ALLOCATION, value: '2' },
];

export function gettingStartedSection(optionLabel: string): LandingPageSection {
  if (optionLabel === LandingPageOption.SHADOW_PNL) {
    return getPnLAllocationStartedSection();
  }
  if (optionLabel === LandingPageOption.FCFIXED_ALLOCATION) {
    return getFCFixedAllocationStartedSection();
  }
  return getLegacyAllocationStartedSection();
}

function getLegacyAllocationStartedSection(): LandingPageSection {
  return {
    title: 'getting_started',
    cards: [
      {
        name: 'create_driver',
        href: '/driver/create',
        description: 'create_driver_description',
      },
      {
        name: 'manage_driver',
        href: '/driver/manage',
        description: 'manage_driver_description',
      },
      {
        name: 'create_allocation',
        href: '/allocation/create',
        description: 'create_allocation_description',
      },
      {
        name: 'manage_allocation',
        href: '/allocation/manage',
        description: 'manage_allocation_description',
      },
    ],
  };
}

function getPnLAllocationStartedSection(): LandingPageSection {
  const configureOrViewCards: LandingPageCard[] = [];
  configureOrViewCards.push(
    getConfigureSingleSliceCard(),
    getConfigureSliceGroupCard(),
  );

  const cards: LandingPageCard[] = [
    {
      name: 'allocation_methodology',
      level: 1,
    },
    ...configureOrViewCards,
    {
      name: 'fcfixed_allocations',
      level: 1,
    },
    {
      name: 'slice_manage_allocation',
      href: '/slice/allocation/manage',
      description: 'manage_slice_allocation_description',
    },
    {
      name: 'slice_reporting',
      level: 1,
    },
    {
      name: 'slice_view_report',
      href: 'https://beta-reporting.allocations.finergy.amazon.dev/',
      description: 'view_slice_report_description',
      external: true,
    },
  ];

  return {
    title: 'getting_started',
    cards,
  };
}

function getFCFixedAllocationStartedSection(): LandingPageSection {
  const cards: LandingPageCard[] = [
    {
      name: 'drivers',
      level: 1,
    },
    {
      name: 'create_fcfixed_driver',
      href: '/fcfixeddriver/create',
      description: 'create_driver_description',
    },
    {
      name: 'manage_fcfixed_driver',
      href: '/fcfixeddriver/manage',
      description: 'manage_driver_description',
    },
    {
      name: 'allocations',
      level: 1,
    },
    {
      name: 'create_fcfixed_allocation',
      href: '/fcfixedallocation/create',
      description: 'create_fcfixed_allocation_description',
    },
    {
      name: 'manage_fcfixed_allocation',
      href: '/fcfixedallocation/manage',
      description: 'manage_slice_allocation_description',
    },
  ];

  return {
    title: 'getting_started',
    cards,
  };
}

export const resources: LandingPageSection = {
  title: 'resources',
  cards: [
    {
      name: 'mappings',
      href: '/general/mappings',
    },
    {
      name: 'reports',
      href: '/general/reports',
    },
    {
      name: 'wiki_page',
      href: Url.wiki,
      external: true,
    },
    {
      name: 'contact_us',
      href: Url.contactUs,
      external: true,
    },
  ],
};

function getConfigureSingleSliceCard(): LandingPageCard {
  return {
    name: 'configure_single_slice',
    href: '/slice/single',
    description: 'configure_single_slice_description',
  };
}

function getConfigureSliceGroupCard(): LandingPageCard {
  return {
    name: 'configure_slice_group',
    href: '/slice/group',
    description: 'configure_slice_group_description',
  };
}
